import '../App.css'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Stack, Pagination } from 'react-bootstrap'
import hylkyservices from '../services/hylkykortti'
//import { useAxiosFetch } from '../hooks/useAxiosFetch';
import config from '../config'
import SortForm from './SortForm'
import he from 'he'

const HylkylistaItem = ({ wreck, windowWidth }) => {
  const [featured, setFeatured] = useState(null)
  /*const [title,setTitle] = useState(null)
  const [created,setCreated]= useState(null)
  const [modified,setModified] = useState(null)
  const [icons,setIcons] =useState([])
  const [excerpt,setExcerpt] = useState(null)
  */

  useEffect(() => {
    if (wreck._embedded && wreck._embedded['wp:featuredmedia']) {
      const newImg = wreck._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url
      setFeatured(newImg)
    } else if (windowWidth >= 576) {
      setFeatured('/img/default-post-image.jpg')
    } else {
      setFeatured(null)
    }
  }, [wreck, windowWidth])

  const cdate = new Date(wreck.date).toLocaleDateString('fi-FI')
  const cmodified = new Date(wreck.modified).toLocaleDateString('fi-FI')
  const iconStyle = {
    width: '25px',
    height: '25px',
  }
  const imgStyle = {
    width: '112px',
    height: '112px',
    border: '1px solid #b6b6b6',
    padding: '5px',
    margin: '5',
  }
  const txtStyle = {
    paddingLeft: '15px',
    marginLeft: '15px',
  }
  //console.log('wrecklist-item',wreck)
  //kokeellinen Card
  /*
  return(
    
    <Card style={{ width: '18rem' }}> 
      {featured?<Card.Img variant="top" src={featured} />:<></>}
     <Card.Body>
      <Card.Title><Link style={{color: "#5b7b95"}} to={`/hylkykortti/${wreck.id}`}>{wreck.title.rendered}
          {wreck.meta.hylytnet_muut_nimet.length===0?<></>
          :<>({wreck.meta.hylytnet_muut_nimet.join(',')})</>}
          <span>
            <img src={`http://localhost:8080/${wreck.marker}`} style={iconStyle} /> 
          {wreck.loc_icons.map(icon =>(
            <img src={`http://localhost:8080/${icon}`} style={iconStyle} />
          ))}
          </span>
          </Link></Card.Title>
      <Card.Text>
      <div>Julkaistu: {cdate}, Muokattu: {cmodified}</div>
      <div dangerouslySetInnerHTML={{ __html: wreck.excerpt.rendered }} />
      </Card.Text>
     </Card.Body>
      
   
    </Card>
  )
*/
  const getNameString = (wreck) => {
    if (wreck.meta) {
      if (wreck.meta.hylytnet_muut_nimet.length > 0) {
        //
        return wreck.title.rendered.concat(' (').concat(wreck.meta.hylytnet_muut_nimet.join(',')).concat(')')
      }
    }
    return wreck.title.rendered
  }

  return (
    <Row key={wreck.id} className="d-flex flex-column flex-sm-row">
      {featured ? (
        <Col xs="12" sm="auto" className="mb-2 mb-sm-0">
          <img src={featured} style={{ ...imgStyle, maxWidth: '100px', float: 'left' }} alt="Featured img" />
        </Col>
      ) : null}
      <Col>
        <div>
          <h3>
            <Link style={{ color: '#5b7b95' }} to={`/hylkykortti/${wreck.id}`}>
              {he.decode(getNameString(wreck))}
              <span>
                <img src={`${wreck.cat_icon}`} style={iconStyle} alt="cat icon" />
                {wreck.loc_icons.map((icon) => (
                  <img src={`${icon}`} style={iconStyle} alt="loc icons" key={icon.concat(wreck.id)} />
                ))}
              </span>
            </Link>
          </h3>
          <div>
            Julkaistu: {cdate}, Muokattu: {cmodified}
          </div>
          <div dangerouslySetInnerHTML={{ __html: wreck.excerpt.rendered }} key={`story_${wreck.id}`} />
        </div>
      </Col>
    </Row>
  )
}

const Hylkylista = ({ wrecklist }) => {
  const [windowWidth, setWindowWidth] = useState(null)
  const [page, setPage] = useState([])
  const [currentPageNum, setCurrentPageNum] = useState(1)
  const [pageCount, setPageCount] = useState(null)
  const [paginationNumbers, setPaginationNumbers] = useState([])
  //const [wrecksTotal,setWrecksTotal] =useState(null)
  //const [catList,setCatList]=useState(null)
  //const [locList,setLocList]=useState(null)

  //sortParams
  const [sortField, setSortField] = useState('title')
  const [sortDirection, setSortDirection] = useState('nouseva')
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [showSpinner, setShowSpinner] = useState(false)
  const [data, setData] = useState(undefined)

  const getSortedWrecklist = () => {
    const copy = [...wrecklist]
    switch (sortField) {
      case 'date':
        return copy.sort((a, b) =>
          sortDirection === 'nouseva'
            ? new Date(a.date).getTime() - new Date(b.date).getTime()
            : new Date(b.date).getTime() - new Date(a.date).getTime(),
        )
      case 'modified':
        return copy.sort((a, b) =>
          sortDirection === 'nouseva'
            ? new Date(a.modified).getTime() - new Date(b.modified).getTime()
            : new Date(b.modified).getTime() - new Date(a.modified).getTime(),
        )
      default:
        return copy.sort((a, b) =>
          sortDirection === 'nouseva'
            ? a.title.rendered.localeCompare(b.title.rendered, 'fi')
            : b.title.rendered.localeCompare(a.title.rendered, 'fi'),
        )
    }
  }

  const getPageIds = (sorted, pageNum) =>
    sorted
      .map((wreck) => wreck.id)
      .slice(
        pageNum === 1 ? 0 : (pageNum - 1) * itemsPerPage,
        sorted.length >= pageNum * itemsPerPage ? pageNum * itemsPerPage : sorted.length,
      )

  const getPaginationNumbers = (pagesCount) => {
    const maxVisible = windowWidth < 576 ? 5 : 10
    if (pagesCount <= maxVisible) {
      return Array.from({ length: pagesCount }, (_, i) => i + 1)
    }

    const half = Math.floor(maxVisible / 2)
    let start = Math.max(1, currentPageNum - half)
    let end = start + maxVisible - 1

    if (end > pagesCount) {
      end = pagesCount
      start = end - maxVisible + 1
    }

    return Array.from({ length: maxVisible }, (_, i) => start + i)
  }

  const setPagination = () => {
    const pagesCount = Math.ceil(wrecklist.length / itemsPerPage)
    setPageCount(pagesCount)
    setPaginationNumbers(getPaginationNumbers(pagesCount))
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    setWindowWidth(window.innerWidth)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setPagination()
  }, [windowWidth])

  useEffect(() => {
    const fetchData = async () => {
      const fetchIds = wrecklist.length > 0 ? getPageIds(getSortedWrecklist(), currentPageNum) : null
      try {
        const newData = await hylkyservices.foo({
          baseURL: config.SERVER,
          method: 'GET',
          url: '/wp-json/wp/v2/ait-dir-item',
          params: {
            _fields:
              'id,title,date,modified,excerpt,marker,cat_icon,loc_icons,meta.hylytnet_muut_nimet,featured_media,_links,_embedded',
            _embed: 'wp:featuredmedia',
            per_page: '22',
            include: fetchIds ? fetchIds.join(',') : null,
          },
        })
        if (newData) {
          setData(newData)
        }
      } catch (error) {
        console.log('Error fetching newData')
      }
    }

    if (data && wrecklist.length > 0) {
      fetchData()
      setPagination()
    }
  }, [currentPageNum])

  useEffect(() => {
    const fetchData = async () => {
      const fetchIds = wrecklist.length > 0 ? getPageIds(getSortedWrecklist(), 1) : null
      try {
        const newData = await hylkyservices.foo({
          baseURL: config.SERVER,
          method: 'GET',
          url: '/wp-json/wp/v2/ait-dir-item',
          params: {
            _fields:
              'id,title,date,modified,excerpt,marker,cat_icon,loc_icons,meta.hylytnet_muut_nimet,featured_media,_links,_embedded',
            _embed: 'wp:featuredmedia',
            per_page: '22',
            include: fetchIds ? fetchIds.join(',') : null,
          },
        })
        if (newData) {
          setData(newData)
        }
      } catch (error) {
        console.log('Error fetching newData')
      }
    }
    setPage([])
    setPagination()

    if (currentPageNum !== 1) {
      setCurrentPageNum(1)
    } else if (wrecklist.length > 0) {
      fetchData()
    }
  }, [wrecklist, sortField, sortDirection])

  useEffect(() => {
    if (data && data.length) {
      const pageNum = currentPageNum ? currentPageNum : 1
      if (pageNum === 1) {
        setPage([])
      }
      const newIds = getPageIds(getSortedWrecklist(), pageNum)
      const newPage = data.sort((a, b) => newIds.indexOf(a.id) - newIds.indexOf(b.id))
      if (pageNum > 1) {
        setPage(newPage)
      } else {
        setPage(newPage)
      }
      //setPageCount(newPageCount)
      setShowSpinner(false)
      //console.log(data);
    } else {
      setPage([])
    }
  }, [data])

  const handlePageChange = (action, page = null) => {
    switch (action) {
      case 'first':
        setCurrentPageNum(1)
        break
      case 'prev':
        setCurrentPageNum(currentPageNum - 1)
        break
      case 'page':
        setCurrentPageNum(page)
        break
      case 'next':
        setCurrentPageNum(currentPageNum + 1)
        break
      case 'last':
        setCurrentPageNum(pageCount)
    }
    setShowSpinner(true)
  }

  if (!wrecklist) {
    return <h2>Latautuu...</h2>
  }

  return (
    <Container>
      {/* loading && <p>loading...</p>*/}
      <Stack gap={5}>
        <div>
          {' '}
          Esitetään {currentPageNum} sivua {Math.ceil(wrecklist.length / itemsPerPage)}:sta sivusta
        </div>
        {/*<div>Järjestetty kentän: {sortField} mukaan, suuntaan: {sortDirection} </div>*/}
        <Row>
          <Col>
            Näytetään {page.length} kaikista {wrecklist.length} kohteesta
          </Col>
          <Col>
            <SortForm
              sortField={sortField}
              setSortField={setSortField}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
            />
          </Col>
        </Row>
        <hr />

        {page.length > 0 ? (
          page.map((wreck) => <HylkylistaItem key={wreck.id} wreck={wreck} windowWidth={windowWidth} />)
        ) : (
          <Row></Row>
        )}
        <Row>
          {showSpinner ? (
            <p>Ladataan...</p>
          ) : (
            <p>
              Näytetään {page.length} hylkykohdetta {wrecklist.length} kohteesta
            </p>
          )}
        </Row>
        <Row>
          <Col>
            {wrecklist.length > page.length ? (
              <Pagination className="justify-content-center justify-content-sm-start">
                <Pagination.First disabled={currentPageNum === 1} onClick={() => handlePageChange('first')} />
                <Pagination.Prev disabled={currentPageNum === 1} onClick={() => handlePageChange('prev')} />
                {paginationNumbers.map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPageNum}
                    onClick={() => handlePageChange('page', page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}
                <Pagination.Next disabled={currentPageNum === pageCount} onClick={() => handlePageChange('next')} />
                <Pagination.Last disabled={currentPageNum === pageCount} onClick={() => handlePageChange('last')} />
              </Pagination>
            ) : null}
          </Col>
        </Row>
      </Stack>
    </Container>
  )
}
Hylkylista.defaultProps = {
  category: 'ait-dir-item-category',
  id: 19,
}
export default Hylkylista
